'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2, _temp;

var _mobx = require('mobx');

var _baseContentmodel = require('base-contentmodel');

var _deepExtend = require('deep-extend');

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _simgateInputStore = require('simgate-input-store');

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimDomainStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = (_temp = _class2 = function (_SimgateInputStore) {
  (0, _inherits3.default)(SimDomainStore, _SimgateInputStore);

  function SimDomainStore(opts) {
    (0, _classCallCheck3.default)(this, SimDomainStore);

    // let visitingId = getQueryVariable(window.location.search, "visiting");
    // if(visitingId){
    //   this.visitingId = +visitingId
    //   this.simgate.updateData = this.simgate.execCommand = function(args, cb){ 
    //     console.warn("in readonly mode!");
    //     if(typeof cb === "function") cb(); 
    //   }         
    // }
    var _this = (0, _possibleConstructorReturn3.default)(this, (SimDomainStore.__proto__ || (0, _getPrototypeOf2.default)(SimDomainStore)).apply(this, arguments));

    _initDefineProp(_this, 'teamName', _descriptor, _this);

    _initDefineProp(_this, 'contextIsLoaded', _descriptor2, _this);

    _initDefineProp(_this, 'pathId', _descriptor3, _this);

    _initDefineProp(_this, 'currentRoundNo', _descriptor4, _this);

    _initDefineProp(_this, 'teamStateName', _descriptor5, _this);

    _initDefineProp(_this, 'visitingId', _descriptor6, _this);

    _this.props = opts;
    var _this$props = _this.props,
        simgate = _this$props.simgate,
        projectDomainStore = _this$props.projectDomainStore,
        parentPathId = _this$props.parentPathId,
        simulation = _this$props.simulation;


    _this.teamName = projectDomainStore.context.user.userID + "@" + simulation.id;

    (0, _mobx.when)(function () {
      return _this.contextIsLoaded;
    }, function () {

      var context = window.application.dataModel.domainStore.context;
      // var simulation = window.application.Project.children[0];
      _this.pathId = context.team.pathId;
      _this.currentRoundNo = context.team.num5 || 1;
      _this.teamStateName = context.team.num4 || simulation.rounds[_this.currentRoundNo - 1].teamStates[0].id;

      // reload sim variable data on any teamstate change
      if (_this.loadableVariableNames.length) {
        (0, _mobx.reaction)(function () {
          return _this.teamStateName;
        }, function () {
          return _this.loadData();
        });
      }
    });

    // kick it off
    _this.refreshContext();
    return _this;
  }

  (0, _createClass3.default)(SimDomainStore, [{
    key: 'refreshContext',
    value: function refreshContext(cb, errCb) {
      var _props = this.props,
          simgate = _props.simgate,
          projectDomainStore = _props.projectDomainStore,
          parentPathId = _props.parentPathId,
          simulation = _props.simulation;


      var userId = projectDomainStore.context.user.id;

      // get the team and session information
      var self = this;
      this.simgate.execQuery({
        query: "custom-queries://getContextData",
        parameters: { userId: userId }
      }).then(function (result) {

        projectDomainStore.context.team = {
          id: result.data[0][0].PathID,
          name: result.data[0][0].Name,
          pathId: result.data[0][0].PathID,
          pathType: result.data[0][0].PathType,
          parentId: result.data[0][0].ParentID,
          attr1: result.data[0][0].Attr1,
          attr2: result.data[0][0].Attr2,
          attr3: result.data[0][0].Attr3,
          attr4: result.data[0][0].Attr4,
          attr5: result.data[0][0].Attr5,
          num1: result.data[0][0].Num1,
          num2: result.data[0][0].Num2,
          num3: result.data[0][0].Num3,
          num4: result.data[0][0].Num4,
          num5: result.data[0][0].Num5
        };
        projectDomainStore.context.user.pathId = result.data[0][0].UserTeamID;
        projectDomainStore.context.sessionName = result.data[0][0].SessionName;

        self.pathId = projectDomainStore.context.team.pathId;
        self.currentRoundNo = projectDomainStore.context.team.num5 || 1;
        self.teamStateName = projectDomainStore.context.team.attr4;
        self.parentPathId = projectDomainStore.context.team.parentId;
        self.contextIsLoaded = true;

        if (typeof cb === "function") cb();
      }).catch(errCb);
    }
  }, {
    key: 'completeTask',
    value: function completeTask(cb, errcb) {
      var _this2 = this;

      var getInput = this.getInput,
          setInput = this.setInput,
          saveData = this.saveData,
          _props2 = this.props,
          simulation = _props2.simulation,
          _dtos = _props2.simulation._dtos;


      if (false && inLastState) {
        setInput(this, "isSimOver", true);
        saveData(function () {
          return _this2.refreshContext(cb, errcb);
        });
      } else {
        var taskArgs = [this.simgate.execCommand, {
          path: this.pathId,
          command: "Advance"
        }, {
          onSuccess: function onSuccess() {
            return _this2.refreshContext(cb, errcb);
          },
          onFailure: errcb
        }];

        if (this.simgate.runTask) {
          var _simgate;

          (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
        } else if (this.simgate.AsyncTask) {
          var asyncTask = new this.simgate.AsyncTask();
          asyncTask.runTask.apply(asyncTask, taskArgs);
        } else {
          this.simgate.execCommand(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
        }
      }
    }
  }, {
    key: 'context',

    // accomodating simgate-domain-store
    get: function get() {
      return { pathID: this.pathId };
    }
  }, {
    key: 'isVisiting',
    get: function get() {
      return !!this.visitingId;
    }

    // @TODO

  }, {
    key: 'inLastState',
    get: function get() {
      var simulation = this.simulation,
          _dtos = this.simulation._dtos;
    }
  }]);
  return SimDomainStore;
}(_simgateInputStore2.default), _class2.id = "domainStore", _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'teamName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'contextIsLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'pathId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'context', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'context'), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'currentRoundNo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'teamStateName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'visitingId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isVisiting', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isVisiting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'inLastState', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'inLastState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'refreshContext', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'refreshContext'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'completeTask', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'completeTask'), _class.prototype)), _class));
exports.default = SimDomainStore;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimDomainStore, 'SimDomainStore', 'src/core_modules/sim-domain-store/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/sim-domain-store/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/sim-domain-store/index.js
// module chunks = 0